
import React, { Fragment, useContext, useState } from 'react';
import { H6, H5, Image, UL, LI } from '../../../AbstractElements';
import SvgIcon from '../../Common/Component/SvgIcon';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, Input } from 'reactstrap';

const AlleServices = ({ data }) => {

      const history = useNavigate(); 

      const [isMenuHovering, setIsMenuHovering] = useState(false);

      const itemStyle = {
        backgroundColor: isMenuHovering ? '#4c9dc02b' : '#ffffff',
        padding: '10px',
        cursor: 'pointer',
      };
    //onClick={() => addWishList(item)} <Link to={`${process.env.PUBLIC_URL}/eservices/EServiceDetail/`+item.code}> 

    const viewEserviceDetail = (item) => {//alert(item.code);
      history(`${process.env.PUBLIC_URL}/eservices/EServiceDetail/${item.code}`);
    };
   
  return (
    <UL attrUL={{ className: 'schedule-list d-flex' }}>  
      {data.map((item, i) => (
        <LI key={i} attrLI={{onClick: (e) => viewEserviceDetail(item), className: `${item.color}`}} 
              onMouseEnter={() => setIsMenuHovering(true)}
              onMouseLeave={() => setIsMenuHovering(false)}
              style={itemStyle}
            >
          
                                   
          
          <Image attrImage={{ src: require(`../../../assets/images/dashboard/user/${item.image}`), alt: 'DRTS eService' }} />
                                  
          
          <div style={{ margin:0, padding:0, width:"90%"}}>

            <H5 className='mb-1' ><span style={{fontWeight:450}}>{item.title}</span></H5> 
            
            <UL >
              <LI attrLI={{ className: 'f-light' }}>
                <SvgIcon iconId={item.icon} className='fill-icon f-light' />
                <span>{item.date}</span>
              </LI>
              <LI attrLI={{ className: 'f-light' }}>
                <SvgIcon iconId={item.icon2} className='fill-icon f-success' />
                <span> {item.date2}</span>
              </LI>
            </UL>
          </div>
         
             
        </LI>
      ))}
    </UL>
  );
};

export default AlleServices;
